import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import VisionaryLeadership from "./sections/VisionaryLeadership";
import TheArtisanBehindTheBrush from "./sections/TheArtisanBehindTheBrush";
import CoreDisciplines from "./sections/CoreDisciplines";
import TechnicalSolutions from "./sections/TechnicalSolutions";
import WhereWeWork from "./sections/WhereWeWork";
import ReadyToBuild from "./sections/ReadyToBuild";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <VisionaryLeadership />
      <TheArtisanBehindTheBrush />
      <CoreDisciplines />
      <TechnicalSolutions />
      <WhereWeWork />
      <ReadyToBuild />
      <Footer />
    </div>;
}